module.exports = __webpack_public_path__ + "img/fa1b005.jpeg";